import { useSyncExternalStore } from 'react';

const MOBILE_BREAKPOINT = 768;

const getIsMobile = () => window.innerWidth < MOBILE_BREAKPOINT;
const getServerSnapshot = () => false;

export function useIsMobile() {
  const isMobile = useSyncExternalStore(
    (callback) => {
      const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
      mql.addEventListener('change', callback);
      return () => mql.removeEventListener('change', callback);
    },
    getIsMobile,
    getServerSnapshot,
  );

  return isMobile;
}
